import React from "react";
import { ArrayField, Datagrid, DateField, TextField, BooleanField, FunctionField } from "react-admin";
import { Typography, Grid } from "@mui/material";
import VersionActions from "./VersionActions";

const VersionList = ({
  mode,
  pageName,
  route,
  activeVersionId = "",
  futureActiveVersion = "",
  temporaryVersions = [],
}) => {
  const isNotAvaliableForDel = recordId => {
    const isTemp = temporaryVersions?.some(x => x?.id === recordId);
    const isActive = recordId == activeVersionId;
    const isFuture = recordId == futureActiveVersion;
    return isActive || isFuture || isTemp;
  };

  return (
    <Grid
      item
      xs={12}
      sm={7}
      lg={8}
    >
      <Typography variant="body1">Версии:</Typography>

      <ArrayField
        source="versions"
        emptyText="Няма налични версии"
      >
        <Datagrid
          bulkActionButtons={false}
          empty={<Typography>Няма налични версии</Typography>}
          source="versions"
        >
          <FunctionField
            label=""
            render={record => (
              <TextField
                source="id"
                color={`${isNotAvaliableForDel(record.id) ? "primary" : ""}`}
              />
            )}
          />
          <FunctionField
            label=""
            render={record => (
              <TextField
                source="name"
                label="Име"
                color={`${isNotAvaliableForDel(record.id) ? "primary" : "#"}`}
              />
            )}
          />
          <DateField
            source="createdAt"
            label="Създаден на"
            showTime
          />
          <TextField
            source="user"
            label="Потребител"
          />
          <FunctionField
            label=""
            render={record => (
              <VersionActions
                mode={mode}
                pageName={pageName}
                route={route}
                isAvaliableForDel={!isNotAvaliableForDel(record.id)}
              />
            )}
          />
        </Datagrid>
      </ArrayField>
    </Grid>
  );
};

export default VersionList;
